import { render, staticRenderFns } from "./SetNewPasswordModal.vue?vue&type=template&id=d5f028ba"
import script from "./SetNewPasswordModal.vue?vue&type=script&lang=js"
export * from "./SetNewPasswordModal.vue?vue&type=script&lang=js"
import style0 from "./SetNewPasswordModal.vue?vue&type=style&index=0&id=d5f028ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports